// extracted by mini-css-extract-plugin
export default {"tooltip":"k42wsx","visible":"oXURsX"};